import React, { ReactElement, useState } from 'react';
import classNames from 'classnames';

import { TabPanel } from './TabPanel';
import { TabList, TabListItem } from './TabList';

import './Tabs.scss';

export interface TabsProps {
  children;
  activeTab?: string;
  items: TabListItem[];
  extraClasses?: string | string[];
  onChange?: (tabId: string) => void;
}

export const Tabs: React.FC<TabsProps> = ({ activeTab, children, items, extraClasses, onChange }) => {
  const [currentTabId, setCurrentTabId] = useState(activeTab || items[0].id);

  const handleTabClick = (tabId: string) => {
    setCurrentTabId(tabId);
    onChange?.(tabId);
  };

  return (
    <div className={classNames('tabs', extraClasses)}>
      <TabList items={items} activeTab={currentTabId} onTabClick={handleTabClick} />
      {React.Children.map(children as ReactElement, (child: React.ReactElement) => (
        <TabPanel key={child.props.id} isActive={child.props.id === currentTabId}>
          {child}
        </TabPanel>
      ))}
    </div>
  );
};
